import { useState } from 'react';
import { LinkBracket, LinkIfHref } from '@components';
import FormSearchIcon from '@images/icon-search-s.svg';
import { hnaviSearchMethod, hnaviSearchName } from '@constants';
import { hnaviSearchPath } from '@paths';

export interface NestedMenuItemData {
  label: string;
  href?: string;
  children?: NestedMenuItemData[];
}

const HnaviHeaderSpMenuItem: React.FC<{ item: NestedMenuItemData }> = ({
  item: { label, children, href },
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <LinkIfHref href={href}>
        <div
          className='flex items-center justify-between border-t-2 border-white py-4 font-bold text-primary'
          onClick={() => {
            if (children) {
              setOpen((prev) => !prev);
            }
          }}
        >
          <div>{label}</div>
          <LinkBracket className={`${open ? 'rotate-90' : ''}`} />
        </div>
      </LinkIfHref>
      <div className={`${open ? '' : 'hidden'} ml-4`}>
        {children?.map((item) => (
          <HnaviHeaderSpMenuItem item={item} key={item.label} />
        ))}
      </div>
    </>
  );
};

const SearchForm = () => (
  <form
    className='relative'
    action={hnaviSearchPath()}
    method={hnaviSearchMethod}
  >
    <input
      name={hnaviSearchName}
      className='my-2 w-full rounded-md bg-white py-4 pl-4 pr-12 focus:outline-none'
    />
    <div className='absolute bottom-0 right-3 top-0 flex items-center'>
      <button
        type='submit'
        className='w-5 cursor-pointer'
        aria-label='メニュー'
      >
        <img
          src={FormSearchIcon.src}
          alt='search'
          width={FormSearchIcon.width}
          height={FormSearchIcon.height}
        />
      </button>
    </div>
  </form>
);

export const HnaviHeaderSpMenu: React.FC<{ items: NestedMenuItemData[] }> = ({
  items,
}) => (
  <div className='fixed inset-0 top-16 z-10 flex flex-col overflow-y-auto bg-lightgray'>
    <div className='container mx-auto'>
      <SearchForm />
      {items.map((item) => (
        <HnaviHeaderSpMenuItem key={item.label} item={item} />
      ))}
    </div>
  </div>
);
